import { render, staticRenderFns } from "./PolicyFull.vue?vue&type=template&id=1a2cb600"
import script from "./PolicyFull.vue?vue&type=script&lang=js"
export * from "./PolicyFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports